import { render, staticRenderFns } from "./table-data.vue?vue&type=template&id=12363efa&"
import script from "./table-data.vue?vue&type=script&lang=js&"
export * from "./table-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports